<div class="overlay-backdrop" (click)="closeFullscreen()">
  <div class="player-modal" (click)="$event.stopPropagation()">
    <div id="vimeo-fullscreen-player"></div>
    <button class="close-button" (click)="closeFullscreen()">
      <fa-icon [icon]="['fas', 'times']"></fa-icon>
    </button>
  </div>
</div>